import { postContactMessage } from '../services/api/requests/ContactUs'
import { postNewsletterSubscription } from '../services/api/requests/Dashboard'

// eslint-disable-next-line import/prefer-default-export
export function doContactUsSubmit() {
  return async (values, state) => {
    state.setStatus({})
    state.setSubmitting(true)
    try {
      await postContactMessage(values)
      if (values.hasOwnProperty('isCheckSubs')) {
        if (values['isCheckSubs'] === true) {
          await postNewsletterSubscription({ emailAddress: values.email })
        }
      }
      state.resetForm()
      state.setStatus({
        message: 'Sent! Thank you for leaving us a message',
      })
    } catch (error) {
      const { data = {} } = error.response || {}
      const { message = 'Network Error' } = data || {}

      if (data.status === 422) {
        state.resetForm()
        state.setStatus({
          message: 'Sent! Thank you for leaving us a message',
        })
        return
      }

      state.setStatus({
        error: message,
      })
    }
    state.setSubmitting(false)
  }
}
